<template>
  <DataListStateful
    title="Типы упаковок"
    resource="package-types"
    store="packageTypes"
    :columns="columns"
    :filter-options="filter"
    :disable-adding="isAdmin ? false : true"
  />
</template>

<script>
import { userRoles } from "../../enums/user-roles.js";
import auth from "../../auth.js";
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: true },
        { title: "Наименование", name: "title", sortable: true },
        { title: "Сокращение", name: "shortTitle", sortable: true },
        { title: "Длина, м", name: "length", sortable: true },
        { title: "Ширина, м", name: "width", sortable: true },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        shortTitle: {
          title: "Сокращение",
          type: "text",
        },
        length: {
          title: "Длина, м",
          type: "decimal",
        },
        width: {
          title: "Ширина, м",
          type: "decimal",
        },
      },
    };
  },
  computed: {
    isAdmin() {
      const user = auth.getUser();
      if (user.roles.find(r => r.id === userRoles.Admin)) {
        return true;
      }
      return false;
    },
  },
};
</script>
